import { environment } from 'src/environments/environment';

export const BASE_URL = 'https://mbusiness20dev.mobile.com.py/mbusiness-api/api/';

// export const BASE_URL = environment.baseUrl;
